import NoHistory from "../NoHistory";
import { useEffect, useState } from "react";
import moment from "moment";
import { BsDownload } from "react-icons/bs";
import { Dialog, DialogContent } from "../ui/dialog";
import { FaDownload, FaShare } from "react-icons/fa";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { cn } from "@/lib/utils";
import { FcCancel } from "react-icons/fc";
import { MdSupportAgent } from "react-icons/md";
import { useSelector } from "react-redux";
import parse from "html-react-parser";
import { Badge } from "../ui/badge";
import axios from "axios";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";
import { toast } from "sonner";
import { Capacitor } from "@capacitor/core";

const RecentActivities = () => {
  const user = useSelector((state) => state.user.user);
  const [transactions, setTransactions] = useState([]);

  let theme = window.localStorage.getItem("theme") || "light";

  // console.log(window.matchMedia("(prefers-color-scheme: dark)").matches);

  useEffect(() => {
    if (user && user?.transactions?.length > 0) {
      setTransactions(user.transactions);
    }
  }, [user]);
  const formatter = new Intl.NumberFormat("en-US");
  const [currentTransaction, setCurrentTransaction] = useState(false);
  const [, setDialogOpen] = useState(false);
  const platform = Capacitor.getPlatform();

  const [isLoading, setIsLoading] = useState(false);

  async function printReciept(download = false) {
    try {
      setIsLoading(true);
      setIsLoading(true);
      const prefix = platform != "web" ? "" : "https://backend-new.billzpay.com.ng"
      // alert(`${prefix}/api/reciept/${currentTransaction.id}`)
      const response = await axios.get(`${prefix}/api/reciept/${currentTransaction.id}`, {
        withCredentials: true,
        responseType: 'blob'
      })


      let fileName = `billzpay-${new Date().toISOString()}.pdf`;

      if (download) {
        if (platform === "web") {
          const url = URL.createObjectURL(response.data);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'receipt.pdf';
          a.click();
          URL.revokeObjectURL(url);
        } else {
          fileName = "billzpay-reciept.pdf"
          const permission = await Filesystem.requestPermissions();
          if (permission.publicStorage === "granted") {
            const downloadsDir = window.cordova.file.externalRootDirectory + 'Download/';
            // const base64Data = await blobToBase64(response.data);
            window.resolveLocalFileSystemURL(downloadsDir, function (dirEntry) {
              alert(fileName)
              dirEntry.getFile(fileName, { create: true }, function (fileEntry) {
                fileEntry.createWriter(function (fileWriter) {
                  fileWriter.onwriteend = function () {
                    const shouldOpen = confirm("Receipt downloaded. Open it now?");
                    if (shouldOpen) {
                      window.cordova.plugins.fileOpener2.open(
                        fileEntry.nativeURL,
                        'application/pdf',
                        {
                          error: function (e) {
                            console.error('Error opening file', e);
                            alert(JSON.stringify(e));
                          },
                          success: function () {
                            console.log('Receipt opened successfully');
                          }
                        }
                      );
                    } else {
                      alert(`Receipt saved to Downloads/${fileName}`);
                    }
                  };
                  fileWriter.onerror = function (e) {
                    console.error('Write failed', e);
                    alert(JSON.stringify(e));
                  };
                  fileWriter.write(response.data);
                }, console.error);
              }, console.error);
            }, console.error);
          } else {
            toast.error("Permission denied. Please allow access to your files to download the receipt.")
          }

        }
      } else {
        const base64Data = await blobToBase64(response.data);
        // alert(base64Data)

        // Save to Filesystem
        await Filesystem.writeFile({
          path: fileName,
          directory: Directory.Temporary,
          data: base64Data,
        });

        // Get file URI and share it
        const uriResult = await Filesystem.getUri({
          path: fileName,
          directory: Directory.Temporary,
        });

        await Share.share({
          title: 'Transaction Receipt',
          text: 'Here is your transaction receipt',
          files: [uriResult.uri]
        });
      }
    } catch (error) {
      console.error('Error handling receipt:', error)
    } finally {
      setIsLoading(false);
    }
  }

  // Convert Blob to base64
  function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        const dataUrl = reader.result;
        const base64 = dataUrl.split(',')[1]; // Strip the data URL prefix
        resolve(base64);
      };
      reader.readAsDataURL(blob);
    });
  }

  return (
    <div>
      <Dialog
        open={Boolean(currentTransaction)}
        onOpenChange={() => setCurrentTransaction(false)}
      >
        <DialogContent
          className="text-dark font-jakarta dark:bg-darkInput border-0 bg-gray-50 md:w-[400px] lg:w-[400px] dark:text-white"
          id="reciept"
        >
          <div className="mt-4 flex items-center justify-between">
            <div className="flex w-32 cursor-pointer items-center gap-x-1">
              {theme == "dark" ? (
                <img
                  src={"/logo-image.svg"}
                  alt="logo-symbol"
                  className="w-[110px]"
                />
              ) : (
                <img
                  src={"/logo-image-black.svg"}
                  alt="logo-symbol"
                  className="w-[110px]"
                />
              )}
            </div>

            <p className="text-sm font-medium">Transaction Details</p>
          </div>

          <div className="mt-3.5 flex flex-col items-center justify-center gap-2">
            <h2
              className={cn(
                "font-inter text-center text-xl leading-3 font-bold",
                {
                  "text-baseColor": currentTransaction?.status
                    ?.toLowerCase()
                    ?.includes("suc"),
                  "text-red-500": !currentTransaction?.status
                    ?.toLowerCase()
                    ?.includes("suc"),
                },
              )}
            >
              ₦{formatter.format(currentTransaction?.amount || 0)}.00
            </h2>

            {currentTransaction?.status?.toLowerCase()?.includes("suc") ? (
              <div className="flex items-center gap-2">
                <p className="font-geist text-base">Successful</p>

                <IoShieldCheckmarkOutline />
              </div>
            ) : (
              <div className="flex items-center gap-1">
                <p className="font-geist text-base">Failed</p>

                <FcCancel />
              </div>
            )}

            <p className="font-geist text-center text-xs">
              {moment(currentTransaction?.created_at).format(
                "Do MMM, h:mm:ssA",
              )}
            </p>
          </div>

          <div className="dark:bg-darkBorder h-[0.1px] w-full bg-gray-300"></div>

          <div className="flex flex-col gap-2">
            <div className="font-geist flex items-center justify-between text-sm">
              <p className="font-medium text-gray-500">Transaction Type</p>

              <p className="text-xs font-medium">
                {currentTransaction.type === ""
                  ? "Admin Funding"
                  : currentTransaction.type}
              </p>
            </div>

            <div className="font-geist flex items-center justify-between text-sm">
              <p className="font-medium text-gray-500">Number</p>

              <p className="text-xs font-medium">#{currentTransaction.id}</p>
            </div>

            <div className="font-geist flex gap-2 text-sm">
              <p className="font-medium text-gray-500">Details</p>

              <p className="flex-1 text-right text-xs font-medium">
                {parse(currentTransaction.description || "")}
              </p>
            </div>
          </div>

          <div className="share hidden text-center opacity-70">...</div>

          <div id="controls">
            <div className="flex gap-2">
              <button
                className="disabled:opacity-50 not-last:bg-primary font-geist flex w-full items-center justify-center gap-2 rounded-lg px-2 py-2 text-sm font-medium text-white transition-all"
                onClick={() => printReciept(false)}
                disabled={isLoading}
              >
                <FaShare size={18} />
                {isLoading ? "Generating receipt" : "Share"}
              </button>

            </div>
          </div>

          <div className="flex flex-col items-center justify-center gap-2 text-center text-xs">
            <div className="flex flex-col items-center justify-center gap-2 text-center text-xs">
              <p className="text-center font-medium text-gray-500">
                {currentTransaction?.status?.toLowerCase()?.includes("suc")
                  ? "support"
                  : "Facing any issues?"}
              </p>

              <p className="text-primary font-medium">
                support@billzpay.com.ng
              </p>
              {currentTransaction?.status?.toLowerCase()?.includes("suc") || (
                <>
                  <p>Or</p>
                  <button
                    className="flex items-center justify-center gap-2 rounded-md bg-blue-600 px-3 py-2 text-xs text-white"
                    onClick={() => {
                      window.HubSpotConversations.widget.open();
                    }}
                  >
                    <MdSupportAgent size={20} /> Chat with support
                  </button>
                </>
              )}
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <div className="flex items-center justify-between">
        <h1 className="mt-7 text-lg font-semibold">Recent Activities</h1>
        {/* <Link
          to="/dashboard/transactions"
          className="text-primary cursor-pointer text-sm font-medium transition-all hover:underline dark:text-gray-300"
        >
          View all
        </Link>{" "} */}
      </div>

      {transactions?.length === 0 ? (
        <NoHistory />
      ) : (
        <div className="flex flex-col gap-4 pt-3">
          {transactions?.slice(0, 5).map((transaction, index) => (
            <button
              key={index}
              className="flex cursor-pointer items-center justify-between text-start"
              onClick={() => {
                setCurrentTransaction(transaction);
                setDialogOpen(true);
              }}
            >
              <div className="flex items-center justify-between gap-2">
                <div
                  className={`rounded-full ${transaction.status?.toLowerCase()?.includes("suc") ? "bg-green-500" : "bg-sky-500"} flex h-[50px] w-[50px] items-center justify-center`}
                >
                  {transaction?.type === "Account Deposit" ? (
                    <BsDownload className="text-xl font-bold text-white" />
                  ) : transaction.type === "" ? (
                    <span className="text-xl font-semibold text-white">AD</span>
                  ) : (
                    <span className="text-xl font-semibold text-white">
                      {transaction.type[0]}
                    </span>
                  )}
                </div>
                <div>
                  <h1 className="text-[14px] font-medium text-black/85 dark:text-white">
                    {transaction?.type === ""
                      ? "Admin Funding"
                      : transaction?.type}
                  </h1>

                  <p className="dark:text-darkGray text-[12px] text-gray-600">
                    {moment(transaction?.created_at).format("MMM Do, h:mm:ssA")}
                  </p>
                </div>
              </div>

              <div className="flex flex-col items-center">
                <p className="font-inter text-[14px] font-medium lg:text-base lg:font-semibold dark:text-white">
                  {transaction?.type === "Account Deposit" && "+"}₦
                  {formatter.format(transaction?.amount)}
                </p>
                {/* <p
                  className={`rounded-sm ${transaction.status?.toLowerCase()?.includes("suc") ? "bg-green-100 text-green-500 dark:bg-green-50" : "bg-red-100 text-red-700 dark:bg-red-100"} p-[2px] text-[10px]`}
                >
                  {transaction.status}
                </p> */}
                <Badge
                  className={cn(
                    "border-transparent text-white",
                    transaction.status?.toLowerCase()?.includes("suc")
                      ? "bg-green-600 focus-visible:ring-green-600/20 dark:bg-green-600/60 dark:focus-visible:ring-green-600/40 [a&]:hover:bg-green-600/90"
                      : "bg-destructive dark:bg-destructive/60 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 [a&]:hover:bg-destructive/90",
                  )}
                >
                  {transaction.status}
                </Badge>{" "}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentActivities;